import React from 'react';
import {withStyles} from '@material-ui/core/styles'
import {FormControl, InputLabel, MenuItem, OutlinedInput, Select,} from '@material-ui/core';
import {PhotoSizeSelectActual} from "@mui/icons-material";

const styles = {
  select: {
    boxSizing:'border-box',
    height: '34px',
    backgroundColor: '#ffffff',
    '& > div:first-child': {
      boxSizing: 'border-box',
      height: '34px',
      padding: '6px 32px 6px 14px',
      verticalAlign: 'middle',
      display: 'flex',
      alignItems: 'center',
      '& > span:nth-child(2)': {
        display: 'inline !important'
      },
      '& > span:last-child': {
        display: 'none'
      },
    }
  },
  hide:{
    display: 'none',
    marginLeft: '0.25rem',
    textTransform: 'uppercase',
    fontSize: '0.7225rem',
    fontWeight: 500,
  }
};

function IconSizeControl(props) {
  const {
    iconSize, setIconSize, iconSizeOptions,
    classes
  } = props;

  const abbv = iconSize === "Small" ? "sm" : iconSize === "Medium" ? "md" : "lg";
  const iconSizeIcons = (opt) => {
    switch (opt){
      case 'Small': return <PhotoSizeSelectActual style={{fontSize:'12px'}} />;
      case 'Medium': return <PhotoSizeSelectActual style={{fontSize:'16px'}} />;
      case 'Large': return <PhotoSizeSelectActual style={{fontSize:'20px'}} />;
      default: return null;
    }
  };

  return (
    <>
      {iconSizeOptions.length > 1 ? (
        <FormControl
          variant="outlined"
        >
          <InputLabel style={{flexShrink: 0, transform: 'translate(14px, -6px) scale(1)', fontSize: '0.7225em'}}>
            Icon Size:
          </InputLabel>
          <Select
            id="dataIconSize"
            className={classes.select}
            value={iconSize}
            onChange={setIconSize}
            input={<OutlinedInput margin='dense' label="Icon Size"/>}
          >
            {iconSizeOptions.map((size) => (
              <MenuItem key={size} value={size}>{iconSizeIcons(size)}<span className={classes.hide}>{abbv}</span><span style={{paddingLeft:'0.5rem'}}>{size}</span></MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null }
    </>
  )
}

export default withStyles(styles)(IconSizeControl);
